import React from "react";
import { useNavigate } from "react-router-dom";
import ServerDown from "../assets/admin/ServerDown.svg";

const ServerDownPage = () => {
  const navigate = useNavigate();

  const handleBackHome = () => {
    navigate("/dashboard");
  };

  return (
    <div className="flex items-center justify-center min-h-screen mx-auto">
      <div className="text-center space-y-8">
        <img src={ServerDown} alt="ServerDown" className="mx-auto" />
        <div className="space-y-1">
          <h2 className="text-5xl leading-none font-extrabold tracking-tight">
            Something Went Wrong
          </h2>
          <p className="text-base leading-6 font-normal text-gray-500">
            It looks like our servers are having some issues. Try refreshing the
            page after some time.
          </p>
        </div>
        <div className="mt-10 flex gap-3 justify-center">
          <button
            className="px-4 py-2 rounded-md bg-primary text-text1"
            onClick={handleBackHome}
          >
            Go back home
          </button>
          <button className="px-4 py-2 rounded-md border border-text1">
            Contact support
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServerDownPage;
